import { map, tap } from 'rxjs/operators';
import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { Blocs } from '@business/blocs';
import { LoadingState } from '@core/utils/repository/loading_state';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { R } from '@core/utils/r';
import { CommonService } from '@business/services';
import { ChecklistId, ChecklistResponse } from '@business/entities/checklist';

export class TodosPageBloc extends BaseBloc {
  private readonly userBloc = resolve(Blocs.user);
  private readonly todoBloc = resolve(Blocs.todo);
  private readonly taskBloc = resolve(Blocs.task);
  private readonly orgBloc = resolve(Blocs.organization);
  private readonly checklistBloc = resolve(Blocs.todoChecklists);
  private readonly teamBloc = resolve(Blocs.team);
  private readonly taskStatusBloc = resolve(Blocs.taskStatus);

  constructor(private readonly checklistId: ChecklistId) {
    super();
  }

  readonly loading = new LoadingState({ loading: false });

  readonly users$ = this.userBloc.staff$;
  readonly tasks$ = this.todoBloc.tasks$.pipe(map(items => R.sortBy(items, item => item.menuOrder)));
  readonly checklists$ = this.checklistBloc.checklists$;
  readonly taskStatuses$ = this.taskStatusBloc.statuses$;

  teams$ = this.teamBloc.teams$;
  allUsers$ = this.userBloc.staff$;

  onInit() {
    return forkJoin([
      this.teamBloc.fetchTeams(),
      this.userBloc.fetchUsers(),
      this.todoBloc.fetchTasks(),
      this.taskStatusBloc.fetchTaskStatuses(),
      this.checklistBloc.fetchChecklists(this.checklistId),
    ]).pipe(this.loading.run());
  }

  onReload() {
    this.taskBloc.fetchTasks().subscribe();
  }

  onTodoReload() {
    this.todoBloc.fetchTasks().subscribe();
  }

  createTask = this.todoBloc.createTask;
  updateTask = this.todoBloc.updateTask;
  orderTasks = this.todoBloc.orderTasks;
  deleteTask = this.todoBloc.deleteTask;
  setComplete = this.todoBloc.setComplete;
  setChecklistComplete = this.checklistBloc.toggleStep;
  search = this.checklistBloc.search;
  searchTask = this.todoBloc.search;
  updateAssignne = this.checklistBloc.updateAssignne;

  searchOrganizations = (search: string) => {
    return this.orgBloc.searchOrganizations(search).pipe(map(data => CommonService.selectItems(data.data, 'name', 'id')));
  };
}
